import styled from 'styled-components';

import { getSpacing } from 'stylesheetB2b';

export const Container = styled.div`
  position: absolute;
  z-index: 100;
  top: ${getSpacing(2)};
  right: ${getSpacing(2)};
`;

export const CameraContainer = styled.div`
  position: relative;
`;

export const CountDownStyle = styled.p`
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 5rem;
  color: white;
  font-weight: bold;
  transform: translate(-50%, -50%);
`;
